import React, { useMemo, useState, useEffect } from 'react';
import { Box } from '../../../primitives/Box/Box.es.js';
import '../../../primitives/Center/styled.es.js';
import '../../../primitives/Group/Group.es.js';
import '../../../primitives/Grid/Grid.es.js';
import '../../../primitives/Level/Level.es.js';
import '../../../primitives/Shelf/Shelf.es.js';
import '../../../primitives/Portal/Portal.es.js';
import '../../../primitives/Hidden/Hidden.es.js';
import '../../../primitives/Media/Media.es.js';
import '../../../primitives/Dialog/Dialog.es.js';
import '../../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../../primitives/Popper/Popper.es.js';
import '../../../primitives/DragHandle/DragHandle.es.js';
import '../../../primitives/Pin/Pin.es.js';
import { Progress } from '../../Progress/Progress.es.js';
import Styled from './styled.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const DotSelected = ({ onClick, dotIndex, transitionDelay }) => {
  const [progress, setProgress] = useState(0);
  const handleClick = () => {
    onClick(dotIndex);
  };
  useEffect(() => {
    setProgress(transitionDelay ? 1 : 0);
  }, [transitionDelay]);
  return /* @__PURE__ */ React.createElement(Styled.DotWrapper, {
    as: "button",
    onClick: handleClick,
    tabIndex: -1
  }, /* @__PURE__ */ React.createElement(Styled.AbsoluteBox, null, /* @__PURE__ */ React.createElement(Progress, {
    size: 16,
    strokeWidth: 6,
    progress,
    transitionDelay
  })));
};
const DotUnSelected = ({ onClick, dotIndex }) => {
  const handleClick = () => {
    onClick(dotIndex);
  };
  return /* @__PURE__ */ React.createElement(Styled.DotWrapper, {
    as: "button",
    onClick: handleClick,
    tabIndex: -1
  }, /* @__PURE__ */ React.createElement(Styled.AbsoluteBox, {
    borderRadius: "50%",
    border: "4px solid transparent"
  }, /* @__PURE__ */ React.createElement(Styled.Circle, {
    opacity: 0.35,
    backgroundColor: "neutral.100"
  })));
};
const DotNavigation = (_a) => {
  var _b = _a, {
    dotPosition,
    dotSize,
    length,
    currentSelection,
    onClick,
    transitionDelay = 0
  } = _b, props = __objRest(_b, [
    "dotPosition",
    "dotSize",
    "length",
    "currentSelection",
    "onClick",
    "transitionDelay"
  ]);
  const MemoizedDots = useMemo(() => new Array(length).fill(true).map((_, index) => /* @__PURE__ */ React.createElement(Styled.GroupItem, {
    key: `$indicator-${index}`
  }, currentSelection === index && /* @__PURE__ */ React.createElement(DotSelected, {
    onClick,
    dotIndex: index,
    transitionDelay
  }), currentSelection !== index && /* @__PURE__ */ React.createElement(DotUnSelected, {
    onClick,
    dotIndex: index
  }))), [currentSelection, length, onClick, transitionDelay]);
  return /* @__PURE__ */ React.createElement(Box, null, /* @__PURE__ */ React.createElement(Styled.GroupWrapper, __spreadValues({
    dotSize,
    dotPosition,
    gutter: "sm",
    justifyContent: "center"
  }, props), MemoizedDots));
};

export { DotNavigation as default };
//# sourceMappingURL=DotNavigation.es.js.map
